<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title2">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">I would like to give special thanks to Jennifer Reyna, a librarian with the E.N. Ziegler South Carolina History Room at the Florence County Library, and Don Kausler Jr., regional editor of the <i>Florence Morning News</i>. They both helped me with gathering together the missing pieces of historical information and photos that were needed to make this book complete. I would also like to thank my father and mother, Don and Sharon Bradley, two lifelong learners whose passion for learning, history, photography, reading and writing significantly inspired me and also encouraged me to inspire and enlighten others to become lifelong learners as well.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?5df6f078